import { createSlice } from '@reduxjs/toolkit';
import { getFirestore, collection, doc, getDoc, getDocs } from 'firebase/firestore';
//
import { dispatch } from '../store';

const initialState = {
  isLoading: false,
  error: null,
  pastes: [],
  paste: null,
  pasteFail: false,
};

const slice = createSlice({
  name: 'pastes',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getPastesSuccess(state, action) {
      state.isLoading = false;
      state.pastes = action.payload;
    },
    getPasteSuccess(state, action) {
      state.isLoading = false;
      state.paste = action.payload;
      state.pasteFail = false;
    },
    getPasteFail(state) {
      state.isLoading = false;
      state.pasteFail = true;
    },
  },
});

export default slice.reducer;

export function getPastes() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const db = getFirestore();
      const pastesCollection = collection(db, 'pastes');
      const querySnapshot = await getDocs(pastesCollection);
      const pastes = [];
      querySnapshot.forEach((docSnap) => {
        pastes.push({ id: docSnap.id, ...docSnap.data() });
      });
      dispatch(slice.actions.getPastesSuccess(pastes));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPaste(pasteId) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const db = getFirestore();
      const pasteDocument = doc(db, 'pastes', pasteId);
      const docSnapshot = await getDoc(pasteDocument);
      if (docSnapshot.exists()) {
        dispatch(slice.actions.getPasteSuccess(docSnapshot.data()));
      } else {
        dispatch(slice.actions.getPasteFail());
      }
    } catch (error) {
      dispatch(slice.actions.getPasteFail());
      dispatch(slice.actions.hasError(error));
    }
  };
}
